import React from "react";
import { ReactComponent as DateIcon } from "../../../../icons/target_date.svg";
import { useSelector } from "react-redux";
import { HpgclTitle } from "../../components";
import { TabSwitcher } from "../../Hppc_Das";
import Hamburger from "../../../../components/Hamburger";
import { ReactComponent as GNAiIcon } from "../../../../icons/gnai_logo.svg";
import { PageHeader } from "../../../../components/Page";
// interface SessionInfoProps {
//   OptimizerSessionToken?: string;
//   selectDate?: string;
// }

const MainHeader = () => {
  const SelectedStartDate = useSelector(
    (state: any) => state.SurplusOptimizerHPPCDate.startDate
  );
  const SelectedEndDate = useSelector(
    (state: any) => state.SurplusOptimizerHPPCDate.endDate
  );
  // const OptimizerSessionToken = useSelector(
  //     (state: any) => state.OptimizerRuvnlSessionToken.OptimizerSessionToken);

  const formatDateWithSuffix = (dateString: string): string => {
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear();

    const month = date.toLocaleString("default", { month: "short" });

    // Add suffix to the day (1st, 2nd, 3rd, etc.)
    const getDayWithSuffix = (d: number): string => {
      if (d > 3 && d < 21) return `${d}th`;
      switch (d % 10) {
        case 1:
          return `${d}st`;
        case 2:
          return `${d}nd`;
        case 3:
          return `${d}rd`;
        default:
          return `${d}th`;
      }
    };

    return `${getDayWithSuffix(day)} ${month} ${year}`;
  };
  const TargetStartDate = formatDateWithSuffix(SelectedStartDate);
  const TargetEndDate = formatDateWithSuffix(SelectedEndDate);
  return (
    <PageHeader
      leftComponent={
        <div className="flex flex-row md:gap-x-4 gap-x-2 items-center">
          <GNAiIcon width={80} />
          <Hamburger />
          <TabSwitcher />
          <h1 className="text-[16px] text-[#6F6D7C]">
            Power-Balance Planner
          </h1>
        </div>
      }
      middleComponent={<HpgclTitle />}
      rightComponent={
        <div className="flex items-end gap-2 px-3 py-1 text-sm">
          <div className="flex-1 text-end">
            <div className="flex items-center justify-end gap-1">
              <DateIcon className="w-5 h-5" />
              <p className="text-xs text-[#34656D] font-medium">
                Target Date Range
              </p>
            </div>
            <p className="text-sm font-medium text-[#6F6D7C]">
              {TargetStartDate} - {TargetEndDate}
            </p>
          </div>
        </div>
      }
    />
  );
};

export default MainHeader;  